const doc = [({"en":({"js":({"merfoto":({"components":({"sheet-layouts":({"presentation":({"photo_types_mismatch":"Your photos are on their way"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;